import logo from './logo.svg';
import About_us from './pages/About_us';
import Contact_us from './pages/Contact_us';
import Courses from './pages/Courses';
import Gallery from './pages/Gallery';
import Ourservices from './pages/Ourservices';
import Addenquiry from './pages/Addenquiry';
import Home from "./pages/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="about-us" element={<About_us />} />
          <Route path="courses" element={<Courses />} />
          <Route path="contact-us" element={<Contact_us />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="our-services" element={<Ourservices />} />
          <Route path="add-enquiry" element={<Addenquiry />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
